module.exports = __webpack_public_path__ + "img/8DB6B5C4.52b12c86.png";